
import { getCurrentInstance, provide, ref, watch } from 'vue'
import ExplainKpiMetrics from '../../../components/explain/explain-kpi-metrics.component.vue'
import DistributionChart from '../../../components/insights/analytics/distribution-chart.component.vue'
import KpisSuccess from '../../../components/insights/analytics/kpis-success.component.vue'
import Pivots from '../../../components/insights/analytics/pivots/pivots.component.vue'
import Tabs from '../../../components/tabs.component.vue'
import { mapActions, useContextQuery, useKpis } from '../../../composables'
import { useReloadDistDataWhenFiltersChange } from '../../../composables/use-reload-dist-data-when-filters-change'
import { ANALYTICS_CONSTS } from '../../../store/analytics/analytics.consts'

export default {
  name: 'SearchMetrics',
  components: {
    DistributionChart,
    ExplainKpiMetrics,
    Tabs,
    KpisSuccess,
    Pivots,
  },
  setup(_, { emit }) {
    const {
      proxy: { $epb, $store },
    } = getCurrentInstance()

    provide('hideClearFiltersButton', true)

    const { kpiOptions } = useKpis()
    const { query } = useContextQuery()

    const { setSelectedId } = mapActions($store, ANALYTICS_CONSTS.moduleName, {
      setSelectedId: ANALYTICS_CONSTS.actions.setSelectedId,
    })
    const { loadDistData } = mapActions($store, ANALYTICS_CONSTS.moduleName, {
      loadDistData: ANALYTICS_CONSTS.actions.loadDistData,
    })

    const METRICS_OPTIONS = {
      EVOLUTION_OVER_TIME: 'evolution',
      FUNNEL: 'funnel',
      QUERIES_DISTRIBUTION: 'distribution',
    } as const

    const tabsMessages = $epb.messages.explain.queryAnalysis.sections.searchMetrics.tabs

    const tabOptions = [
      {
        id: METRICS_OPTIONS.EVOLUTION_OVER_TIME,
        text: tabsMessages[METRICS_OPTIONS.EVOLUTION_OVER_TIME],
      },
      { id: METRICS_OPTIONS.FUNNEL, text: tabsMessages[METRICS_OPTIONS.FUNNEL] },
      {
        id: METRICS_OPTIONS.QUERIES_DISTRIBUTION,
        text: tabsMessages[METRICS_OPTIONS.QUERIES_DISTRIBUTION],
      },
    ]

    const selectedTabId = ref(tabOptions[0].id)

    watch(
      query,
      async (query: string): Promise<void> => {
        await setSelectedId(query)
        await loadData(query)
      },
      { immediate: true },
    )

    const { isLoading } = useReloadDistDataWhenFiltersChange()

    watch(isLoading, (isLoading: boolean): void => {
      emit('isLoading', isLoading)
    })

    async function loadData(query: string): Promise<void> {
      emit('isLoading', true)
      await loadDistData(query)
      emit('isLoading', false)
    }

    return {
      baseClass: 'epb-search-metrics',
      selectedTabId,
      tabOptions,
      kpiOptions,
      query,
      METRICS_OPTIONS,
    }
  },
}
